var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useTheme } from '../Theme/Theme';
import { buttonColor } from '../../helpers/color';
import { Loading } from '../Loading';
import { Text } from '../Text';
import { classes } from '../../helpers';
import { style } from './style';
export const Button = (props) => {
    const { size: __size, shape: __shape, displayBlock: __displayBlock, icon, flat: __flat, className, loading, component, onClick, outline: __outline, primary, secondary, danger, link } = props, rest = __rest(props, ["size", "shape", "displayBlock", "icon", "flat", "className", "loading", "component", "onClick", "outline", "primary", "secondary", "danger", "link"]);
    const BaseElement = (p) => {
        if (component) {
            return React.cloneElement(props.component, p);
        }
        if (rest.href !== undefined || link) {
            return React.cloneElement(React.createElement("a", Object.assign({}, p)));
        }
        return React.cloneElement(React.createElement("button", Object.assign({}, p)));
    };
    const theme = useTheme();
    const css = style(theme, props);
    if (rest.href !== undefined || link) {
        return (React.createElement(BaseElement, Object.assign({ className: classes(css.anchor, css.default, className), onClick: (e) => !loading && onClick && onClick(e) }, rest),
            icon,
            React.createElement(Loading, { color: buttonColor(props, theme, primary, secondary, danger, link)[1], isLoading: loading, size: "small", render: () => React.createElement("span", null, props.children) })));
    }
    const buttonProps = rest;
    return (React.createElement(BaseElement, Object.assign({ className: classes(css.default, css.button, className), onClick: (e) => !loading && onClick && onClick(e) }, buttonProps),
        icon,
        React.createElement(Loading, { style: { margin: '0' }, color: buttonColor(props, theme, primary, secondary, danger, link)[1], isLoading: loading, size: "small", render: () => React.createElement("span", null, props.children) }),
        loading && React.createElement(Text, { margin: "0 10px" }, "Loading")));
};
Button.defaultProps = {
    size: 'default',
    shape: 'default',
    type: 'button',
};
//# sourceMappingURL=Button.js.map